import store from '@/store/index';
import { MaterialInput } from '@/types/material';
import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';

export default function material(axios: any) {
  async function getMaterials(filter: any) {
    const filterString = filterValueToQuery(filter);
    const LAST_KNOWN_MATERIALS_FILTER = await store.getters.GET_LAST_KNOWN_MATERIALS_FILTER();
    const RAN_MATERIALS = await store.getters.GET_RAN_MATERIALS();
    if (!RAN_MATERIALS || LAST_KNOWN_MATERIALS_FILTER !== filterString) {
      await store.dispatch('GET_MATERIALS', filterString);
    }
    try {
      const response = await (store.getters.GET_MATERIALS());
      return response;
    } catch (e) {
      console.error('[api/material] getMaterials Error', e);
    }
    return null;
  }

  async function getMaterialsStats(filter: any) {
    try {
      const response = await axios.get(`/api/materials/stats?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/material] getMaterials Error', e);
    }
    return 0;
  }

  async function getMaterial(id: number) {
    const response = await axios.get(`/api/materials/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/material] updateMaterial Error', e);
    }
    return null;
  }

  async function createMaterial(payload: MaterialInput) {
    const response = await axios.post('/api/materials', camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/material] createMaterial Error', e);
    }
    return null;
  }

  async function updateMaterial(id: number | string, payload: MaterialInput) {
    const response = await axios.put(`/api/materials/${id}`, camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/material] updateMaterial Error', e);
    }
    return null;
  }

  async function deleteMaterial(id: number) {
    const response = await axios.delete(`/api/materials/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/material] deleteMaterial Error', e);
    }
    return null;
  }

  async function getMaterialPurchaseHistories(filter: any) {
    const { id } = filter;
    const functionFilter = filter;
    delete (functionFilter.id);
    const response = await axios.get(`/api/materials/${id}/poHistory?${filterValueToQuery(filter)}`);
    try {
      if (response.status === 200) {
        return { data: { ...response.data.items, latest_price: response.data.latest_price } };
      }
    } catch (e) {
      console.error('[api/material] getMaterialPurchaseHistories Error', e);
    }
    return null;
  }

  async function getMaterialUsageHistories(filter: any) {
    const { id } = filter;
    const functionFilter = filter;
    delete (functionFilter.id);
    const response = await axios.get(`/api/materials/${id}/usageHistory?${filterValueToQuery(filter)}`);
    try {
      if (response.status === 200) {
        return { data: response.data.items };
      }
    } catch (e) {
      console.error('[api/material] getMaterialUsageHistories Error', e);
    }
    return null;
  }

  return {
    getMaterials,
    getMaterial,
    getMaterialsStats,
    createMaterial,
    updateMaterial,
    deleteMaterial,
    getMaterialPurchaseHistories,
    getMaterialUsageHistories,
  };
}
